

const rowPerPageOptions = [{ text: '10', id: 10 }, { text: '25', id: 25 }, { text: '50', id: 50 }, { text: '100', id: 100 }]
const pageSize = 10;

var langs = {
    vietnam: 'vi',
    english: 'en'
}

var theme = {
    light: 'light',
    dark: 'dark',
    premium: 'premium'
}

export default {
    rowPerPageOptions,
    pageSize,
    langs,
    theme
}
